import React, { useEffect } from 'react';
import { Dropdown, Button, Checkbox, MenuProps, DropdownProps } from 'antd';
import { LoadingOutlined, SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getUserConfig, updateUserConfig } from '@/api/subtitles';

interface DropdownConfigProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useDropdownConfig = () => {
  const [open, setOpen] = React.useState(false);

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '3') {
      setOpen(false);
    }
  };

  const handleOpenChange: DropdownProps['onOpenChange'] = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpen(nextOpen);
    }
  };

  return {
    open,
    setOpen,
    handleMenuClick,
    handleOpenChange,
  };
};

export const SettingsDropdown: React.FC<DropdownConfigProps> = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const [config, setConfig] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getUserConfig('USER_SUBTITLE_TWO_WAY_NOUN_LIBRARY').then((res: any) => {
      console.log('getUserConfig', res.data.data.USER_SUBTITLE_TWO_WAY_NOUN_LIBRARY);
      setConfig(res.data.data.USER_SUBTITLE_TWO_WAY_NOUN_LIBRARY);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const handleConfigChange = async (value: boolean) => {
    setLoading(true);
    updateUserConfig('USER_SUBTITLE_TWO_WAY_NOUN_LIBRARY', { value }).then((res) => {
      setConfig(value);
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '3') {
      setOpen(false);
    }
  };

  const handleOpenChange: DropdownProps['onOpenChange'] = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpen(nextOpen);
    }
  };

  return (
    <Dropdown
      menu={{
        items: [
          {
            label: (<>
              <label style={{ marginRight: 15 }}>{t('termbase.enableTwoWay')}</label>
              {loading ? <LoadingOutlined /> : <Checkbox checked={config} onChange={(e) => handleConfigChange(e.target.checked)} />}
            </>),
            key: '2',
          },
        ],
        onClick: handleMenuClick,
      }}
      onOpenChange={handleOpenChange}
      open={open}
      placement="bottomLeft"
    >
      <Button icon={<SettingOutlined />} />
    </Dropdown>
  );
};
